import ProductPage from "../../components/ProductPage";
import { physicalSharesData } from "../../data/productsData";
export default function PhysicalShares() { return <ProductPage data={physicalSharesData} />; }